// Advent free gift: the promo countdown, fitting the overlay copy, and adding the
// gift with a qualifying size.
// The promo never ends itself; it runs until the product's template is switched.
// An automatic discount zeroes the gift; mtf-gift-guard.js removes it if the
// calendar leaves the cart.
(function () {
  if (window.__adventGift) return;
  window.__adventGift = true;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // ?discount=CODE applies a code from the link. Shopify's /discount/ redirect
  // drops ?view= in theme previews, so it's applied here instead.
  (function () {
    var code = (new URLSearchParams(location.search).get('discount') || '').trim();
    if (!/^[A-Za-z0-9_-]{1,64}$/.test(code)) return;
    try { if (sessionStorage.getItem('agpDiscount') === code) return; } catch (e) {}
    fetch(root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { try { sessionStorage.setItem('agpDiscount', code); } catch (e) {} })
      .catch(function () {});
  })();

  var cfg = document.querySelector('[data-agp-config]');
  if (!cfg) return;

  var GIFT = parseInt(cfg.dataset.agpGift, 10) || 0;
  var HANDLE = cfg.dataset.agpHandle || '';
  var GIFT_HANDLE = cfg.dataset.agpGiftHandle || '';
  var QUALIFYING = (cfg.dataset.agpQualifying || '').split(',').filter(Boolean);
  var HOUR = 3600000;
  var DAY = 24 * HOUR;

  // "2026-10-26 13:00", or a bare date for the end of that day, in Toronto time.
  var endsAt = (function () {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/.exec((cfg.dataset.agpEnds || '').trim());
    if (!m) return null;
    var timed = m[4] !== undefined;
    var guess = Date.UTC(+m[1], m[2] - 1, +m[3], timed ? +m[4] : 23, timed ? +m[5] : 59, timed ? 0 : 59);
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Toronto', hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = x.value; });
    return 2 * guess - Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second);
  })();

  // Days, then hours in the last 48. Null once the end has passed.
  function timeLeft() {
    var ms = endsAt === null ? 0 : endsAt - Date.now();
    if (ms <= 0) return null;
    var days = ms > 2 * DAY;
    var n = Math.ceil(ms / (days ? DAY : HOUR));
    return { n: n, word: (days ? 'day' : 'hour') + (n === 1 ? '' : 's') };
  }

  // ---- countdown ----------------------------------------------------------

  // The overlay pill and the artwork badge start hidden, so a cached page never
  // shows an empty number. Both hide again once the end has passed.
  function tick(panel) {
    var left = timeLeft();
    [].forEach.call(panel.querySelectorAll('[data-agp-daypill], [data-agp-badge]'), function (el) {
      el.hidden = !left;
      if (!left) return;
      el.querySelector('[data-agp-days]').textContent = left.n;
      var word = el.querySelector('[data-agp-days-word]');
      if (word) word.textContent = left.word;
      else el.querySelector('[data-agp-days] + span').textContent = left.word + ' left';
    });
  }

  // "Show for the selected size only"
  function followSelection(panel) {
    if (panel.dataset.agpBound) return;
    panel.dataset.agpBound = '1';
    function sync() {
      var on = [].some.call(document.querySelectorAll('.js-option:checked'), function (i) {
        return i.value === panel.dataset.agpValue;
      });
      panel.classList.toggle('agp--hidden', !on);
    }
    document.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('js-option')) sync();
    });
    sync();
  }

  function eachPanel(fn) {
    [].forEach.call(document.querySelectorAll('[data-agp-panel]'), fn);
  }

  // Wrapped text keeps its box at the full width, so the photo sits past a gap. Fit
  // the box to its longest line and the photo follows the text.
  function fitCopy(copy) {
    copy.style.width = '';
    var range = document.createRange();
    range.selectNodeContents(copy);
    var rects = range.getClientRects();
    if (!rects.length || rects[0].top === rects[rects.length - 1].top) return;
    var right = 0;
    for (var i = 0; i < rects.length; i++) right = Math.max(right, rects[i].right);
    copy.style.width = Math.ceil(right - copy.getBoundingClientRect().left) + 1 + 'px';
  }

  var fitObserver = window.ResizeObserver && new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var copy = entry.target.querySelector('.agp-banner__copy');
      if (copy) fitCopy(copy);
    });
  });

  function fitOverlay(panel) {
    if (!panel.matches('.agp-banner:not(.agp-banner--block)') || !panel.querySelector('.agp-banner__eyebrow')) return;
    var copy = panel.querySelector('.agp-banner__copy');
    if (!copy) return;
    fitCopy(copy);
    if (fitObserver) fitObserver.observe(panel);
  }

  function init() {
    eachPanel(function (panel) {
      tick(panel);
      if (panel.dataset.agpDisplay === 'selected') followSelection(panel);
      fitOverlay(panel);
    });
  }

  // The page can be served from cache after the gift sells out, so check live
  // stock and take the promo down rather than promise a gift the cart can't add.
  function hideIfSoldOut() {
    if (!GIFT || !GIFT_HANDLE) return;
    fetch(root() + 'products/' + encodeURIComponent(GIFT_HANDLE) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = p && p.variants.filter(function (x) { return x.id === GIFT; })[0];
        if (!v || v.available) return;
        GIFT = 0;
        [].forEach.call(document.querySelectorAll('.agp-banner-row, [data-agp-panel], .agp-ribbon'), function (el) {
          el.remove();
        });
      })
      .catch(function () {});
  }

  // ---- cart ---------------------------------------------------------------

  function post(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add failed (' + r.status + ')');
      return r.json();
    });
  }

  function busy(form, on) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    btn.disabled = on;
    if (on) {
      btn.dataset.agpLabel = btn.innerHTML;
      btn.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>';
    } else if (btn.dataset.agpLabel) {
      btn.innerHTML = btn.dataset.agpLabel;
    }
  }

  // No gift variant means the promo is display only and the cart is left alone.
  if (GIFT) document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!GIFT || !form.matches) return;

    // The sticky bar can't show the size choice, so send people to the picker.
    if (form.matches('[data-sticky-form]')) {
      e.preventDefault();
      e.stopPropagation();
      var picker = document.querySelector('.option-selectors');
      if (!picker) return;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = picker.querySelector('.js-option');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      return;
    }

    if (!form.matches('form.product-purchase-form')) return;
    var idField = form.querySelector('[name="id"]');
    if (!idField || QUALIFYING.indexOf(String(idField.value)) === -1) return;

    // Ours to handle: stop the theme's own ajax submit as well.
    e.preventDefault();
    e.stopPropagation();
    busy(form, true);

    var qtyField = form.querySelector('[name="quantity"]');
    var qty = (qtyField && parseInt(qtyField.value, 10)) || 1;
    var main = { id: parseInt(idField.value, 10), quantity: qty };
    // _advent_gift_for lets the guard match gifts to calendars from any page
    var gift = {
      id: GIFT,
      quantity: qty,
      properties: { _advent_gift: HANDLE, _advent_gift_for: String(idField.value) }
    };

    // cart/add is all or nothing, so a sold-out gift would block the calendar too
    post([main, gift])
      .catch(function () { return post([main]); })
      .then(function () {
        busy(form, false);
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
          bubbles: true, detail: { openDrawer: true }
        }));
      })
      .catch(function (err) {
        busy(form, false);
        console.error('[advent-gift]', err);
        alert('There was an error adding this to your cart. Please try again.');
      });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // the web font changes line widths once it arrives
  if (document.fonts) document.fonts.ready.then(function () { eachPanel(fitOverlay); });
  hideIfSoldOut();
  // the theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', init);
  // keeps an open page's hour count current
  if (endsAt !== null) setInterval(function () { eachPanel(tick); }, 60000);
})();
